import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData } from '@wix/da-bi/pkg/events';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import s from './SellYourArtLink.scss';
// todo: merge with more specific (SEO-wise) url in da-url
const DEVIANTART_SELL_URL = 'https://www.deviantartsell.com';
export const SellYourArtLink = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    const { t  } = useTranslation();
    const isAdopts = useFlag('adoptables');
    const openModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement(ActionBarButton, {
        className: s['button'],
        href: isAdopts ? undefined : DEVIANTART_SELL_URL,
        onClick: isAdopts ? openModal : undefined,
        biData: BiData({
            evid: 353,
            deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId
        })
    }, t('actionbar.sellYourArt')));
};
SellYourArtLink.displayName = 'SellYourArtLink';
export default SellYourArtLink;
